import { useContext, useEffect, useState } from "react";
import { SocketContext } from "../../socket/socket";
import { NoModuleRights, RoleRightsForModule } from "../../utils/utils";
import ActionImg from "../../assets/images/action.svg";
import archiveicn from "../../assets/images/archiveicn.svg";
import actionSync from "../../assets/images/status-sync.svg";
import unsyncImg from "../../assets/images/unsync_icn.svg";
import resyncImg from "../../assets/images/resync.svg";
import editImg from "../../assets/images/edit.svg";
import viewSummary from "../../assets/images/view_summary.svg";
import RedirectIcon from "../../assets/images/redirect.svg";
import renameImg from "../../assets/images/rename.svg";
import trashImg from "../../assets/images/trash.svg";

const DocumentAction = ({
  data,
  subCategories,
  setSubCategories,
  handleArchive,
  syncUnsyncToggle,
  resyncDocument,
  setUuid,
  toggleViewSummaryTextModal,
  setEditUuid,
  setCurrentModal,
  setFileName,
  onUnarchiveClick,
}) => {
  const socketContext = useContext(SocketContext);
  const [updatedStatusDocument, setUpdatedStatusDocument] = useState(null);

  useEffect(() => {
    const documentSuccessEvent = (res) => {
      if (data?.row?.original?.uuid === res.documentUUID) {
        setUpdatedStatusDocument({
          ...updatedStatusDocument,
          ...res,
        });
      }
    }

    if (socketContext?.socket) {
      socketContext.socket.off("success", documentSuccessEvent);
      socketContext.socket.on("success", documentSuccessEvent);
    }

    return () => {
      socketContext?.socket?.off("success", documentSuccessEvent);
    }
  }, [socketContext, updatedStatusDocument]);
  const isSynced = updatedStatusDocument ? updatedStatusDocument.is_synced === 1 : data?.row?.original?.is_synced === 1;
  const syncedValue = isSynced ? 1 : 0;
  const isUnSynced = updatedStatusDocument ? updatedStatusDocument.is_synced === 0 : data?.row?.original?.is_synced === 0;
  const isSyncing = updatedStatusDocument ? updatedStatusDocument.is_synced === 2 : data?.row?.original?.is_synced === 2;

  return (
    <>
      {
        <div className="dropdown action-dropdown">
          {((data?.row?.original?.type === "text" &&
            !NoModuleRights("Create Documents")) ||
            (data?.row?.original?.type === "doc" &&
              !NoModuleRights("Upload Documents"))) && (
            <button
              className="btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={ActionImg} alt="" />
            </button>
          )}
          <ul className="dropdown-menu dropdown-menu-end">
            {/* SYNCED- Trained: 1,
            UNSYNCED- Untrain: 0,
            SYNC_IN_PROGRESS- Training: 2
        */}

            {subCategories === "Documents" && (
              <>
                {((data?.row?.original?.type === "doc" &&
                  RoleRightsForModule("Delete", "Upload Documents")) ||
                  (data?.row?.original?.type === "text" &&
                    RoleRightsForModule(
                      "Write",
                      "Create Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        toggleViewSummaryTextModal(data?.row?.original);
                    }}
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={viewSummary}
                        alt="fileicn"
                        height={18}
                        width={18}
                      />
                    </span>{" "}
                    Summary
                  </li>
                )}
                {((data?.row?.original?.source_type === "single_page" &&
                  RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "sitemap" &&
                    RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "rss_feed" &&
                    RoleRightsForModule(
                      "Write",
                      "Create Documents"
                    ))) && (
                  <li
                    className={`dropdown-item mt-1`}
                    onClick={() =>
                      window.open(data?.row?.original?.source_url)
                    }
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={RedirectIcon}
                        alt="fileicn"
                        height={15}
                        width={15}
                      />
                    </span>{" "}
                    Source
                  </li>
                )}
                {((data?.row?.original?.type === "doc" &&
                  RoleRightsForModule("Delete", "Upload Documents")) ||
                  (data?.row?.original?.type === "text" &&
                    RoleRightsForModule(
                      "Delete",
                      "Create Documents"
                    ))) && (
                  <li
                    className={`dropdown-item mt-1`}
                    onClick={() => {
                      setCurrentModal("deleteModal");
                      setUuid(data?.row?.original?.uuid);
                    }}
                  >
                    <span>
                      <img src={trashImg} alt="" />
                    </span>{" "}
                    Delete
                  </li>
                )}
                {RoleRightsForModule("Write", "Create Documents") && (
                  <li
                    className="dropdown-item mt-1"
                    onClick={() => {
                      setEditUuid(data?.row?.original?.uuid);
                    }}
                  >
                    <span>
                      <img src={renameImg} alt="" />
                    </span>{" "}
                    Rename
                  </li>
                )}
                {((data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Archive", "Create Documents")) ||
                  (data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Archive",
                      "Upload Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        handleArchive(data?.row?.original?.uuid);
                      /* setCurrentModal("archiveModal");
                  setUuid(data?.row?.original?.uuid);
                  setFileName(data?.row?.original?.title); */
                    }}
                  >
                    <span>
                      <img src={archiveicn} alt="" />
                    </span>{" "}
                    Archive
                  </li>
                )}
                {(((data?.row?.original?.is_synced === 0 ||
                  isUnSynced === true) &&
                  data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Sync", "Create Documents")) ||
                  ((data?.row?.original?.is_synced === 0 ||
                    isUnSynced === true) &&
                    data?.row?.original?.type === "doc" &&
                    RoleRightsForModule("Sync", "Upload Documents"))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        syncUnsyncToggle(data?.row?.original?.uuid, 0);
                    }}
                  >
                    <span>
                      {(data?.row?.original?.is_synced === 0 ||
                        isUnSynced === true) && (
                        <img src={actionSync} alt="" />
                      )}
                      {/*  {(data?.row?.original?.is_synced === 2 ||
                    data?.row?.original?.is_synced === 1) && (
                      <img src={unsyncImg} alt="" />
                    )} */}
                    </span>{" "}
                    {(data?.row?.original?.is_synced === 0 ||
                      isUnSynced === true) &&
                      "Train"}
                  </li>
                )}

                {(((data?.row?.original?.is_synced === 2 ||
                  data?.row?.original?.is_synced === 1) &&
                  isUnSynced !== true &&
                  data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Unsync", "Create Documents")) ||
                  ((data?.row?.original?.is_synced === 2 ||
                    data?.row?.original?.is_synced === 1) &&
                    isUnSynced !== true &&
                    data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Unsync",
                      "Upload Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        syncUnsyncToggle(
                          data?.row?.original?.uuid,
                          2
                          /* isSynced !== 1
                            ? data?.row?.original?.is_synced
                            : 1 */
                        );
                      /* setCurrentModal("syncUnsycModal"); */
                      /* setUuid(data?.row?.original?.uuid);
                  setSyncUnsync(data?.row?.original?.is_synced);
                  setFileName(data?.row?.original?.title); */
                    }}
                  >
                    <span>
                      {(data?.row?.original?.is_synced === 2 ||
                        data?.row?.original?.is_synced === 1) &&
                        isUnSynced !== true && (
                          <img src={unsyncImg} alt="" />
                        )}
                    </span>{" "}
                    {(data?.row?.original?.is_synced === 2 ||
                      data?.row?.original?.is_synced === 1) &&
                      isUnSynced !== true &&
                      "Untrain"}
                  </li>
                )}

                {RoleRightsForModule("Write", "Create Documents") &&
                  !isUnSynced && (
                    <li
                      className={
                        isSyncing
                          ? "dropdown-item-disabled dropdown-item mt-1"
                          : `dropdown-item mt-1`
                      }
                      onClick={() => {
                        (data?.row?.original?.is_synced !== 2 ||
                          syncedValue === 1 ||
                          isUnSynced === true) &&
                          resyncDocument(data?.row?.original?.uuid);
                      }}
                    >
                      <span>
                        <img
                          src={resyncImg}
                          width={18}
                          height={18}
                          alt=""
                        />
                      </span>{" "}
                      Retrain
                    </li>
                  )}

                {data?.row?.original?.type === "text" &&
                  data?.row?.original?.source_type === "text" &&
                  RoleRightsForModule("Write", "Create Documents") && (
                    <li
                      className={
                        isSyncing
                          ? "dropdown-item-disabled dropdown-item mt-1"
                          : `dropdown-item mt-1`
                      }
                      onClick={() => {
                        (data?.row?.original?.is_synced !== 2 ||
                          syncedValue === 1 ||
                          isUnSynced === true) &&
                          setSubCategories("createNewDoc");
                        setUuid(data?.row?.original?.uuid);
                      }}
                    >
                      <span>
                        <img className="edit-icn" src={editImg} alt="" />
                      </span>{" "}
                      Edit
                    </li>
                  )}
              </>
            )}
            {subCategories === "Starred" && (
              <>
                {((data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Delete",
                      "Upload Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      toggleViewSummaryTextModal(data?.row?.original);
                      /* setCurrentModal("unarchiveModal");
                setUuid(data?.row?.original?.uuid);
                setFileName(data?.row?.original?.title); */
                      // onUnarchiveClick(data?.row?.original?.uuid)
                    }}
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={viewSummary}
                        alt="fileicn"
                        height={18}
                        width={18}
                      />
                    </span>{" "}
                    Summary
                  </li>
                )}
                {((data?.row?.original?.source_type === "single_page" &&
                  RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "sitemap" &&
                    RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "rss_feed" &&
                    RoleRightsForModule(
                      "Write",
                      "Create Documents"
                    ))) && (
                  <li
                    className={`dropdown-item mt-1`}
                    onClick={() =>
                      window.open(data?.row?.original?.source_url)
                    }
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={RedirectIcon}
                        alt="fileicn"
                        height={15}
                        width={15}
                      />
                    </span>{" "}
                    Source
                  </li>
                )}
                <li
                  className="dropdown-item mt-1"
                  onClick={() => {
                    setEditUuid(data?.row?.original?.uuid);
                  }}
                >
                  <span>
                    <img src={renameImg} alt="" />
                  </span>{" "}
                  Rename
                </li>
                {((data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Archive", "Create Documents")) ||
                  (data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Archive",
                      "Upload Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      handleArchive(data?.row?.original?.uuid);
                      /* setCurrentModal("archiveModal");
                setUuid(data?.row?.original?.uuid);
                setFileName(data?.row?.original?.title); */
                    }}
                  >
                    <span>
                      <img src={archiveicn} alt="" />
                    </span>{" "}
                    Archive
                  </li>
                )}
                {(((data?.row?.original?.is_synced === 0 ||
                  isUnSynced === true) &&
                  data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Sync", "Create Documents")) ||
                  ((data?.row?.original?.is_synced === 0 ||
                    isUnSynced === true) &&
                    data?.row?.original?.type === "doc" &&
                    RoleRightsForModule("Sync", "Upload Documents"))) && (
                  <li
                    className={
                      !isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        syncUnsyncToggle(data?.row?.original?.uuid, 0);
                    }}
                  >
                    <span>
                      {(data?.row?.original?.is_synced === 0 ||
                        isUnSynced === true) && (
                        <img src={actionSync} alt="" />
                      )}
                      {/*  {(data?.row?.original?.is_synced === 2 ||
                    data?.row?.original?.is_synced === 1) && (
                      <img src={unsyncImg} alt="" />
                    )} */}
                    </span>{" "}
                    {(data?.row?.original?.is_synced === 0 ||
                      isUnSynced === true) &&
                      "Train"}
                  </li>
                )}

                {(((data?.row?.original?.is_synced === 2 ||
                  data?.row?.original?.is_synced === 1) &&
                  isUnSynced !== true &&
                  data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Unsync", "Create Documents")) ||
                  ((data?.row?.original?.is_synced === 2 ||
                    data?.row?.original?.is_synced === 1) &&
                    isUnSynced !== true &&
                    data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Unsync",
                      "Upload Documents"
                    ))) && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      (data?.row?.original?.is_synced !== 2 ||
                        syncedValue === 1 ||
                        isUnSynced === true) &&
                        syncUnsyncToggle(data?.row?.original?.uuid, 1);
                    }}
                  >
                    <span>
                      {(data?.row?.original?.is_synced === 2 ||
                        data?.row?.original?.is_synced === 1) &&
                        isUnSynced !== true && (
                          <img src={unsyncImg} alt="" />
                        )}
                    </span>{" "}
                    {(data?.row?.original?.is_synced === 2 ||
                      data?.row?.original?.is_synced === 1) &&
                      isUnSynced !== true &&
                      "Untrain"}
                  </li>
                )}

                {data?.row?.original?.type === "text" && (
                  <li
                    className={
                      isSyncing
                        ? "dropdown-item-disabled dropdown-item mt-1"
                        : `dropdown-item mt-1`
                    }
                    onClick={() => {
                      setSubCategories("createNewDoc");
                      setUuid(data?.row?.original?.uuid);
                    }}
                  >
                    <span>
                      <img className="edit-icn" src={editImg} alt="" />
                    </span>{" "}
                    Edit
                  </li>
                )}
              </>
            )}

            {subCategories === "Archive" && (
              <>
                {((data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Delete",
                      "Upload Documents"
                    ))) && (
                  <li
                    className="dropdown-item mt-1"
                    onClick={() => {
                      toggleViewSummaryTextModal(data?.row?.original);
                      /* setCurrentModal("unarchiveModal");
                setUuid(data?.row?.original?.uuid);
                setFileName(data?.row?.original?.title); */
                      // onUnarchiveClick(data?.row?.original?.uuid)
                    }}
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={viewSummary}
                        height={18}
                        width={18}
                        alt="fileicn"
                      />
                    </span>{" "}
                    Summary
                  </li>
                )}
                {((data?.row?.original?.source_type === "single_page" &&
                  RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "sitemap" &&
                    RoleRightsForModule("Write", "Create Documents")) ||
                  (data?.row?.original?.source_type === "rss_feed" &&
                    RoleRightsForModule(
                      "Write",
                      "Create Documents"
                    ))) && (
                  <li
                    className={`dropdown-item mt-1`}
                    onClick={() =>
                      window.open(data?.row?.original?.source_url)
                    }
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={RedirectIcon}
                        alt="fileicn"
                        height={15}
                        width={15}
                      />
                    </span>{" "}
                    Source
                  </li>
                )}
                {((data?.row?.original?.type === "doc" &&
                  RoleRightsForModule("Delete", "Upload Documents")) ||
                  (data?.row?.original?.type === "text" &&
                    RoleRightsForModule(
                      "Delete",
                      "Create Documents"
                    ))) && (
                  <li
                    className="dropdown-item mt-1"
                    onClick={() => {
                      setCurrentModal("deleteModal");
                      setUuid(data?.row?.original?.uuid);
                      setFileName(data?.row?.original?.title);
                    }}
                  >
                    <span>
                      <img src={trashImg} alt="" />
                    </span>{" "}
                    Delete
                  </li>
                )}
                {((data?.row?.original?.type === "text" &&
                  RoleRightsForModule("Unarchive", "Create Documents")) ||
                  (data?.row?.original?.type === "doc" &&
                    RoleRightsForModule(
                      "Unarchive",
                      "Upload Documents"
                    ))) && (
                  <li
                    className="dropdown-item mt-1"
                    onClick={() => {
                      onUnarchiveClick(data?.row?.original?.uuid);
                      /* setCurrentModal("unarchiveModal");
                setUuid(data?.row?.original?.uuid);
                setFileName(data?.row?.original?.title); */
                      // onUnarchiveClick(data?.row?.original?.uuid)
                    }}
                  >
                    <span>
                      <img
                        className="lang-cmn-icn"
                        src={archiveicn}
                        alt="fileicn"
                      />
                    </span>{" "}
                    Unarchive
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      }
    </>
  );
}

export default DocumentAction;
